export interface GetVehicleListPagingAndFilterResponse {
    isSuccess: boolean
    message: any
    data: GetVehicleListPagingAndFilterResponseData
}

export interface GetVehicleListPagingAndFilterResponseData {
    items: GetVehicleListPagingAndFilterResponseItem[]
    totalRecordCount: number
}

export interface GetVehicleListPagingAndFilterResponseItem {
    vehicleId: string
    companyId: string
    plate: string
    vehicleStatusId: string
    vehicleTypeId: string
    vehicleOwnerId: string
    driverId?: string
    fuelTypeId?: string
    fuelConsumed?: number
    isBlocked: boolean
    blockedDescription?: string
    isCustomActive: boolean
    image?: string
    licenseImage?: string
    fuelTypeName?: string
    vehicleStatusName: string
    vehicleTypeName: string
    vehicleOwnerName: string
    driverName?: string
    vehicleProperties: any[]
    licenseHolderCompanyId: any
    licenseHolderCompanyName: any
    documentSerialNumber: any
    registrationDate: any
    brandDetailId: any
    brandDetailName: any
    brandId: any
    brandName: any
    brandInsuranceNumber: any
    brandDetailInsuranceNumber: any
    chassisNumber: any
    isDeprivationOfRights?: boolean
    rightsOwnerId: any
    rightsOwnerName: any
    tcknVkn: any
    districtId: any
    districtName: any
    countyId: any
    countyName: any
    vehicleClassId: any
    vehicleClassName: any
    modelYear: any
    vehicleColorId: any
    vehicleColorName: any
    engineNumber: any
    pledgeStartDate: any
    pledgeEndDate: any
    netWeight?: number
    width?: number
    volume?: number
    desi?: number
    loadedWeight?: number
    height?: number
    gearboxType?: boolean
    tacometerType?: boolean
    aksCount?: number
    height2?: number
    vehiclePassCards: GetVehicleListPagingAndFilterResponseVehiclePassCard[]
    rentCompanyId?: string
    rentCompanyName?: string
    rentStartDate?: string
    rentEndDate?: string
    rentCurrencyId?: string
    rentCurrencyName?: string
    rentPriceMonthly?: number
    rentDescription?: string
    saleCompanyId?: string
    saleCompanyName?: string
    saleTcknVkn?: string
    salePrice?: number
    saleCurrencyId?: string
    saleCurrencyName?: string
    saleProxyPersonName?: string
    saleProxyStartDate?: string
    saleProxyEndDate?: string
    saleDescription?: string
    periodicalDocuments: GetVehicleListPagingAndFilterResponsePeriodicalDocument[]
    fileArchives: any[]
    createdDate: string
    createdUser: string
    updatedDate: string
    updatedUser: string
    isSelected: boolean
}

export interface GetVehicleListPagingAndFilterResponseVehiclePassCard {
    vehiclePassCardId: string
    cardName: string
    cardNo: string
    isCustomActive: boolean
}

export interface GetVehicleListPagingAndFilterResponsePeriodicalDocument {
    periodicalDocumentId: string
    documentTypeId: string
    documentTypeName: string
    documentNo: string
    startDate: string
    endDate: string
    additionalValue1: string
    additionalValue1Name: string
    dateControl: boolean
    isInUse: boolean
    availableDays: number
}

export const initialGetVehicleListPagingAndFilterResponseData: GetVehicleListPagingAndFilterResponseData = {
    items: [],
    totalRecordCount: 0
}